import React from 'react';
import AppBar from "../../../Components/header/index"
// import AppProvider from "../../../Components/bootstrap"
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Card';
import { makeStyles } from "@material-ui/core/styles";
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { useRedirect } from "react-admin";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { useMentorProfileData } from "../../ScheduleAppointment/hooks"
import { selectMentor } from "./../../ScheduleAppointment/actions"
import { useDispatch } from "react-redux"
import {
  useParams
} from "react-router";
const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: "#F7F7F7",
    }
  },
  Avatar: {
    height: "35px"
  }
}));
export default function Schedule({
  handleSubmit,
  reset,
  submitting,
  pristine,
  values,
  ...props
}) {
  const classes = useStyles();
  const redirect = useRedirect()
  const matches = useMediaQuery("(min-width:600px)");
  const { mentorId } = useParams()
  // const mentorId = localStorage.getItem("user")
  const dispatch = useDispatch()
  const { mentorData } = useMentorProfileData(mentorId)
  
  const handleClick = () => {
    dispatch(selectMentor(mentorData.data))
    redirect('/schedule1')
  }
  console.log("mentorData",mentorData)
  if (!mentorData.loaded) return null
    if (mentorData.error) return null
    const { name,yearsOfExperience,hoursConsulted,profileImage } = mentorData.data
  if (matches) {
    
    return (
      <div className={classes.div} >
        <AppBar />
        <form onSubmit={handleSubmit} noValidate>
          <Typography style={{ paddingTop: "70px", fontSize: "14px", paddingLeft: "4%" }}><p style={{ opacity: "0.8" }}>{props.typography}</p></Typography>

          <div style={{ paddingTop: "0px", paddingLeft: "4%", paddingRight: "4%", }}>
            {/* <Typography style={{padding:"10px",fontSize:"14px"}}><p style={{opacity:"0.7"}}>{props.typography}</p></Typography>Home/ Mentor Profile <b>/Schedule Appointment</b>  */}
            <Paper style={{ marginTop: "0px", padding: "15px", boxShadow: "none", }}>
              <Grid container>
                <Grid item xs={1.5}>
                  <Avatar alt="Mentor" src={profileImage && profileImage !== undefined ? profileImage._url :""} style={{ marginLeft: "15px",height:"120px",width:"120px" }} />
                </Grid>
                <Grid item sm={8.5} xs={6} style={{ marginTop: "10px",marginLeft:"10px" }}>
                  <Typography variant="h4" style={{ fontWeight: "500", }}>{name}</Typography>
                  <Typography variant="h6" style={{ display: "inline",}}>Category</Typography>
                  <Typography style={{ marginTop: "-25px", marginLeft: "120px", background: "#21D77F", color: "white", width: "55px", padding: "2px", borderRadius: "13px", textAlign: "center" }}>98%</Typography>

                  <Typography ><b>{yearsOfExperience}</b> Yrs Experience, <b>{hoursConsulted}+</b> hours of Consulting</Typography>
                </Grid>
                <Grid item sm={2} xs={4}  >
                  {props.showButton ? <Button style={{ color: '#ffffff',background:"#0288D1" ,marginTop: "70px", borderRadius: "10px", textTransform: "none", width: "150px" }}
                    onClick={handleClick}
                  >
                    Schedule Session
              </Button> : null}
                </Grid>
              </Grid>
              <Divider inline style={{ marginTop: "15px", padding: "1px" }} />
            </Paper>

          </div>
        </form>
      </div>
    );
  }

  else {
    return (
      <div className={classes.div} >
        <AppBar />
        <form onSubmit={handleSubmit} noValidate>

          <Typography style={{ paddingTop: "70px", fontSize: "14px", paddingLeft: "4%" }}><p style={{ opacity: "0.8" }}>{props.typography}</p></Typography>

          <div style={{ paddingTop: "0px", paddingLeft: "4%", paddingRight: "4%", }}>
            {/* <Typography style={{padding:"10px",fontSize:"14px"}}><p style={{opacity:"0.7"}}>{props.typography}</p></Typography>Home/ Mentor Profile <b>/Schedule Appointment</b>  */}
            <Paper style={{ marginTop: "0px", padding: "15px", boxShadow: "none", }}>
              <Grid container>
                <Grid item xs={5}>
                  <Avatar alt="Mentor" src={profileImage && profileImage !== undefined ? profileImage._url :""} style={{ height: "120px", width: "115px" }} />
                </Grid>
                <Grid item xs={7} style={{ marginTop: "3px",marginLeft:"-5%" }}>
                  <Typography variant="h4" style={{ fontWeight: "500", }}>{name}</Typography>
                  <Typography variant="h6" style={{ display: "inline", }}>Category</Typography>
                  <Typography style={{ marginTop: "-25px", marginLeft: "100px", background: "#21D77F", color: "white", width: "55px", padding: "2px", borderRadius: "13px", textAlign: "center" }}>98%</Typography>

                  <Typography ><b>21</b> Yrs Experience, <b>50+</b> hours of Consulting</Typography>
                </Grid>
                <Grid item xs={12}>
                {props.showButton ?
                 <Button style={{
                    color: '#ffffff',
                    background:"#0288D1" ,
                    marginTop: "20px",
                    borderRadius: "10px",
                    textTransform: "none",
                    width: "150px" ,
                    marginLeft:"auto",
                    marginRight:"auto",
                    display:"block"
                  }}
                    onClick={handleClick}
                  >
                    Schedule Session
              </Button> : null}
                </Grid>
              </Grid>
              <Divider inline style={{ marginTop: "15px", padding: "1px" }} />
            </Paper>

          </div>
        </form>
      </div>
    );
  }
}





